import { render, staticRenderFns } from "./TimelineItemConfiguration.vue?vue&type=template&id=534dc8ff"
import script from "./TimelineItemConfiguration.vue?vue&type=script&lang=js"
export * from "./TimelineItemConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TimelineItemConfiguration.vue?vue&type=style&index=0&id=534dc8ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports